import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext({ lang: "en", t: (s) => s, toggle: () => {}, setLanguage: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("dl_lang") === "es" ? "es" : "en"; } catch { return "en"; }
  });
  const setLanguage = useCallback((l) => {
    try { localStorage.setItem("dl_lang", l); } catch (_) {}
    setLang(l);
  }, []);
  const toggle = useCallback(() => setLanguage(lang === "en" ? "es" : "en"), [lang, setLanguage]);
  const t = useCallback((en) => (lang === "en" ? en : (translations[en] ?? en)), [lang]);
  return (
    <LanguageContext.Provider value={{ lang, t, toggle, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
